// extracted by mini-css-extract-plugin
export default {"host":"_3tETe","hostVisible":"_2OG3j","main":"ugd-M","spin":"JIZ4e","islands-spin2":"_1WCVd","errors":"c1cJC","error":"_33XCN"};